import { permissionSiteErrorFragment } from "@saleor/fragments/errors";
import { staffMemberFragment } from "@saleor/fragments/staff";
import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";

import { PermissionSiteCreate, PermissionSiteCreateVariables } from "./types/PermissionSiteCreate";
import { PermissionSiteUpdate, PermissionSiteUpdateVariables } from "./types/PermissionSiteUpdate";


export const permissionSiteCreate = gql`
${permissionSiteErrorFragment}
${staffMemberFragment}
mutation PermissionSiteCreate($input: PermissionSiteInput!) {
  permissionSiteCreate(input: $input) {
    errors: permissionSiteErrors {
      ...PermissionSiteErrorFragment
    }
    site {
        name
        users {
          ...StaffMemberFragment
          avatar(size: 48) {
            url
          }
        }
    }
  }
}
`;

export const usePermissionSiteCreate = makeMutation<
PermissionSiteCreate,
PermissionSiteCreateVariables
>(permissionSiteCreate);

export const permissionSiteUpdate = gql`
${permissionSiteErrorFragment}
${staffMemberFragment}
mutation PermissionSiteUpdate(
  $input: PermissionSiteUpdateInput!
) {
  permissionSiteUpdate(input: $input) {
    errors: permissionSiteErrors {
      ...PermissionSiteErrorFragment
    }
    site {
        name
        users {
          ...StaffMemberFragment
          avatar(size: 48) {
            url
          }
        }
    }
  }
}
`;

export const usePermissionSiteUpdate = makeMutation<
PermissionSiteUpdate,
PermissionSiteUpdateVariables
>(permissionSiteUpdate);
